import CallToAction from '../../components/landing-call-to-action/callToAction'
import LandingFeatures from '../../components/landing-features/landingFeatures'
import Footer from '../../components/footer/Footer'
import LandingVideo from '../../components/landing-video/landingVideo'
import Menu from '../../components/menu/menu'
import classes from './landing.module.scss'



export default function Landing() {
  return (
    <div className={classes.module}>
      <div className={classes.header}>
        <Menu />
      </div>
      <div className={classes.content}>
        <CallToAction />
        <LandingVideo />
        <LandingFeatures />
        <Footer />
      </div>
    </div>
  )
}
